import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href='https://linkedin.com/in/linkedin.com/in/simon-wandera-b27b22215' target="_blank"><BsLinkedin/></a>
        <a href='https://github.com/simonwandera' target="_blank"><BsGithub/></a>
        <a href='https://twitter.com/simonmuruka' target="_blank"><BsTwitter/></a>
      
    </div>
  )
}

export default HeaderSocials
